require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-2017-07-18-welcome.json") })
        }
      }, "path---posts-2017-07-18-welcome");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-2017-07-18-welcome!./.cache/json/posts-2017-07-18-welcome.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---posts-2017-07-18-welcome!./.cache/json/posts-2017-07-18-welcome.json
// module chunks = 231608221292675